export default "__VITE_ASSET__C4ldeb$A__"